import axios from 'axios'
// import { reject } from 'core-js/fn/promise';
import Vue from 'vue'
import i18n from '../../../../i18n';
import router from '../../../../router/index';

const state = {
    token: localStorage.getItem('user-token') || '',
    loading: true,
    products: [],
    product: {},
    message: {},
}

const getters = {
    getAllProducts(state){
        return state.products.reverse();
    },
    product(state){
        return state.product;
    },
    getProductResponseMsg(state){
        return state.message;
    },
    getProductName(){
        return state.product.title;
    },
    getUploadedFile(){
      return state.uploaded;
    }
}

const mutations = {
     updateAllProducts(state, products) {
        state.products = products
     },
     updateProduct(state, product) {
        state.product = product
     },
     updateProductResponseMsg(state, message) {
        state.message = message
     },
    fileUploaded(state, message) {
      state.uploaded = message
    }
}

const actions = {
    ['LOAD_ALL_PRODUCTS']: ({commit}) => {
        return new Promise((resolve) => {
        axios.get('product',
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateAllProducts', resp.data.data)
            } else {
              console.log('Error')
            }
            resolve(resp)
            })
        })
    },

    ['CREATE_FILE']: ({commit}, data) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

      reader.onload = () => {
        axios.post('file', reader.result, {
          headers: {
            'Content-Type': data.type,
          }
        }).then(resp => {
          commit('fileUploaded', resp)
          resolve(resp)
        }).catch(err => reject(err))
        };
        reader.readAsArrayBuffer(data);
      })
    },

    ['CREATE_PRODUCT']: ({commit}, formData) => {
        return new Promise((resolve, reject) => {
        axios.post(`product`, formData )
         .then(resp => {
            if(!resp.data.error){
                commit('updateProductResponseMsg', resp.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            router.push(`/${i18n.locale}/products`);
                            toastObject.goAway(0);
                        }
                    }
                });
            } else {
              console.log(resp.data.error)
            }
              resolve(resp)
            })
            .catch(error => {
                Vue.prototype.$Simplert.open({
                    title: error.statusText,
                    message: `<p>${error.data.messages.join('</p><p>')}</p>`,
                    type: 'error'
                })
                reject(error);
            });
        })
      },

      ['EDIT_PRODUCT']: ({commit}, formData) => {
        return new Promise((resolve) => {
        axios.put(`product/${formData.get('productId')}`, formData )
        .then(resp => {
            if(!resp.data.error){
                commit('updateProductResponseMsg', resp.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            router.push(`/${i18n.locale}/products`);
                            toastObject.goAway(0);
                        }
                    }
                });
            }
            resolve(resp)
            }).catch(err => {
            Vue.prototype.$Simplert.open({
                title: err.statusText,
                message: `<p>${err.data.messages.join('</p><p>')}</p>`,
                type: 'error'
            })
        })
        })
      },

      ['GET_PRODUCT']: ({commit}, id) => {
        return new Promise((resolve) => {
        axios.get(`/product/${id}`,
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateProduct', resp.data.data)
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

      ['DELETE_PRODUCT']: ({commit}, id) => {
        return new Promise((resolve) => {
        axios.delete(`/product/${id}`,
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateProductResponseMsg', resp.data.data)
                console.log(resp.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

      ['DELETE_PRODUCTS']: ({commit}, ids) => {
        return new Promise((resolve) => {
        axios.delete(`/product/bulk-delete`,
        { data: ids}).then(resp => {
            if(!resp.data.error){
                commit('updateProductResponseMsg', resp.data.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            router.go();
                            toastObject.goAway(0);
                        }
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

}

export default {
    state,
    getters,
    mutations,
    actions
}
